import React from "react";
import { useRoutes } from "react-router-dom";
import { ProtectedRoute } from "./ProtectedRoute";

import { routesConfig } from "./routesConfig";

const wrapProtectedRoutes = (routes) => {
  return routes.map(({ path, element, protected: isProtected, children }) => ({
    path,
    element: isProtected ? (
      <ProtectedRoute>{React.createElement(element)}</ProtectedRoute>
    ) : (
      React.createElement(element)
    ),
    children: children ? wrapProtectedRoutes(children) : undefined, // Recursively apply to children
  }));
};

// Create a Routes component to render routes dynamically
export const Routes = () => {
  return useRoutes(wrapProtectedRoutes(routesConfig));
};
